import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ChevronDown from '@deliveroo/icon-set/react/ChevronDown';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import styles from './styles.scss';

class CollapsibleSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.isOpen,
    };
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    heading: PropTypes.string,
    isOpen: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    isOpen: true,
    id: undefined,
    heading: undefined,
    onClick: undefined,
  };

  handleOnClick = () => {
    if (this.props.onClick) {
      this.props.onClick({
        filterId: this.props.id,
        filterName: this.props.heading,
        isOpen: !this.state.isOpen,
      });
    }

    this.setState((state) => ({
      isOpen: !state.isOpen,
    }));
  };

  render() {
    const { heading, children } = this.props;
    return (
      <div
        className={classnames(styles.container, {
          [styles.isOpen]: this.state.isOpen,
        })}
      >
        <button type="button" className={styles.toggleButton} onClick={this.handleOnClick}>
          <Heading level={4} size="x-small">
            {heading}
          </Heading>
          <Icon component={ChevronDown} color="teal" size={18} />
        </button>
        <div className={styles.content}>{children}</div>
      </div>
    );
  }
}

export default CollapsibleSection;
